<template>
  <div v-if="!authReady" class="app-boot">
    <div class="app-boot-mark">智启校园演示平台</div>
    <div class="app-boot-text">正在进入系统...</div>
  </div>
  <LoginView v-else-if="!isLoggedIn" />
  <PsychologyLayout v-else-if="isPsychologyRoute" />
  <MedicalLayout v-else-if="isMedical" />
  <DormLayout v-else-if="isDorm" />
  <AdminLayout v-else />
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  name: 'App',
  components: {
    LoginView: defineAsyncComponent(() => import('./views/LoginView.vue')),
    PsychologyLayout: defineAsyncComponent(() => import('./components/layout/PsychologyLayout.vue')),
    AdminLayout: defineAsyncComponent(() => import('./components/layout/AdminLayout.vue')),
    DormLayout: defineAsyncComponent(() => import('./components/layout/DormLayout.vue')),
    MedicalLayout: defineAsyncComponent(() => import('./components/layout/MedicalLayout.vue'))
  },
  computed: {
    authReady() {
      return this.$store.state.authReady
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn
    },
    isPsychologyRoute() {
      return this.$route.path === '/psychology' || this.$route.path.startsWith('/psychology/')
    },
    isMedical() {
      return this.$store.state.role === 'medical'
    },
    isDorm() {
      return this.$store.state.role === 'dorm'
    }
  }
}
</script>

<style scoped>
.app-boot {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #1f2937;
  background: #f7fbff;
}

.app-boot-mark {
  font-size: 22px;
  font-weight: 700;
}

.app-boot-text {
  font-size: 14px;
  color: #667085;
}
</style>
